import domain from './domain';

// Reset credit wallet
export const resetCreditWallet = domain.createEvent('resetCreditWallet');

// Reset credit wallet transactions
export const resetCreditWalletTransactions = domain.createEvent('resetCreditWalletTransactions');
